import { getCollectionRecordList } from '@/api/domain/carsService'
import { FEE_CODE_MAP } from '@/store/dict/rentPlanDict.js'

export function batchOfflineCollectCheck(idList) {
  const ids = idList.split(',')
  // 调用接口前置检验
  return getCollectionRecordList({ ids })
}

// 订单详情页 租赁信息，如果是新滞纳金则显示收取比例, 插入在租金收款方式之后
export function insertItemsInArrayForOrderDetail(leaseInformation) {
  const tempLeaseInformation = [...leaseInformation]
  const payModeNameIndex = tempLeaseInformation.findIndex((item) => item.key === 'payModeName')
  tempLeaseInformation.splice(
    payModeNameIndex + 1,
    0,
    { key: 'lateFeeProportion', name: '滞纳金收取比例' },
    { key: 'interestFreeDays', name: '免息天数' },
  )
  return tempLeaseInformation
}

// 是否是新的滞纳金数据 - 有的接口收款项类型字段返回type而不是fundType （租赁方案详情 - 租赁规则配置）
export function isNewOverdue(rowData = {}) {
  const { lateFeeOpen, fundType, type } = rowData
  return (fundType === FEE_CODE_MAP.ZHI_NA_JIN || type === FEE_CODE_MAP.ZHI_NA_JIN) && lateFeeOpen === 1
}

// 是否是新的滞纳金数据 - 个人租赁订单专用
export function isNewOverdueForRentPlanConfig(rowData = {}) {
  const { type, fundType } = rowData
  return fundType === FEE_CODE_MAP.ZHI_NA_JIN || type === FEE_CODE_MAP.ZHI_NA_JIN
}

export function overdueUtils() {
  // 通过关联单id在table数据中查找对应的应收ID，得到租金的行数据
  const getRentItemByOverdueItem = (relReceivableId) => {
    return this.receiptData.find((item) => item.id === relReceivableId)
  }

  const ifOfflineOverdueItem = (relReceivableState) => {
    // 如果滞纳金对应的租金收款内容为 未完成
    if (relReceivableState === 0) {
      this.$message.warning('租金仍有欠款，请先完成租金收取')
      return true
    }
    return false
  }

  const selectionAllChangeEventForOverdue = (selectedItems) => {
    this.receiptSelectedItems = selectedItems
    this.selectionAllChangeEventForOverdueCallback?.()
  }

  const selectionChangeEventForOverdue = (selectedItems, row, noCheckOverdueItem) => {
    // 勾选租金则把对应的滞纳金也自动勾选，取消租金则把对应的滞纳金也自动取消，但是滞纳金可单独操作不受租金影响
    let tempSelectedItems = [...selectedItems]
    // 通过id，在所有选中项里匹配当前的点击行，判断是当前是选中还是取消
    const currSelected = Boolean(tempSelectedItems.find((item) => item.id === row.id))
    // 点击的是新滞纳金时14 noCheckOverdueItem标识前端是否拦截，不拦截的交由后端接口拦截处理
    if ((row.content === FEE_CODE_MAP.ZHI_NA_JIN || row.content === '滞纳金') && !noCheckOverdueItem) {
      if (currSelected) {
        // 用滞纳金项的关联单id和租金项的应收ID匹配找出租金项
        const rentItem = this.receiptData.find((ite) => ite.id === row.relReceivableId)
        // 如果滞纳金对应的租金收款内容为 未完成
        if (row.relReceivableState === 0) {
          // 判断rentItem是否已在选中项里
          const rentItemSelected = tempSelectedItems.find((ite) => ite.id === rentItem?.id)
          if (!rentItemSelected) {
            this.$refs?.receiptBLMCommonTable?.$refs?.table?.toggleRowSelection(row, false)
            this.$message.warning('租金仍有欠款，请先勾选租金并全额补缴')
            return
          }
        }
      }
    }
    // 点击的是租金时1
    if (row.content === FEE_CODE_MAP.ZU_JIN || row.content === '租金') {
      // 用租金项的应收ID和滞纳金项的关联单id匹配找出滞纳金项
      const overdueItem = this.receiptData.find((ite) => ite.relReceivableId === row.id)
      // 有对应滞纳金项且状态为可选
      const selectable = overdueItem && !(Number(overdueItem.remainAmount) === 0 || overdueItem.receivableState === '已完成' || overdueItem.receivableState === '已关闭')
      if (selectable) {
        // 选中或取消租金
        if (currSelected) {
          tempSelectedItems.push(overdueItem)
          this.$refs?.receiptBLMCommonTable?.$refs?.table?.toggleRowSelection(overdueItem, true)
        } else {
          tempSelectedItems = tempSelectedItems.filter((item) => item.id !== overdueItem.id)
          this.$refs?.receiptBLMCommonTable?.$refs?.table?.toggleRowSelection(overdueItem, false)
        }
      }
    }
    this.receiptSelectedItems = tempSelectedItems

    this.selectionChangeEventForOverdueCallback?.()
  }

  // 通过应收ID在table数据中查找对应的关联单id，得到滞纳金的行数据
  const getOverdueItemByRentItem = (id) => {
    return this.tableDataFrom.tableData.find((item) => item.relReceivableId === id)
  }

  return {
    selectionAllChangeEventForOverdue,
    selectionChangeEventForOverdue,
    getRentItemByOverdueItem,
    ifOfflineOverdueItem,
    getOverdueItemByRentItem,
  }
}
